module.exports = __webpack_public_path__ + "../resources/img/bg_grid2_03.6e59bfce.png";